// extracted by mini-css-extract-plugin
module.exports = {"favorites":"Dw","accountHeader":"Ew","loadMore":"Fw","header":"Gw","listItem":"Hw"};